import { toast } from "react-toastify";
import {
  hiddeLoading,
  showLoading,
} from "../app/modules/Common/_redux/loading/loadiingActions";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
const nProgress = NProgress.configure({
  easing: "ease",
  speed: 100,
  showSpinner: false,
  trickleSpeed: 200,
  minimum: 0.1,
});
export default function setupAxios(axios, store) {
  axios.interceptors.request.use(
    (config) => {
      const {
        auth: { authToken, user },
      } = store.getState();

      if (authToken) {
        config.headers.Authorization = `Bearer ${authToken}`;
        const lang = user?.lang ? user?.lang : "en";
        config.headers["Accept-Language"] = lang;
      }

      const { dispatch } = store;
      if (config.method !== "get") dispatch(showLoading(config.url));
      if (config.method === "get") {
        nProgress.start();
        const url = new URL(window.location.href);
        if (url.pathname === "/fms/stock") {
          dispatch(showLoading(config.url));
        }
      }
      return config;
    },
    (err) => Promise.reject(err)
  );
  axios.interceptors.response.use(
    function(response) {
      const { dispatch } = store;
      dispatch(hiddeLoading(response.config.url));
      if (response.config.method === "get") nProgress.done();
      return response;
    },
    function axiosRetryInterceptor(error) {
      const { dispatch } = store;
      if (error?.response?.config?.method === "get") nProgress.done();
      if (!!error?.response?.config.url) {
        dispatch(hiddeLoading(error?.response?.config.url));
      } else {
        // Network error ==> response = undefined
        dispatch(hiddeLoading(error?.config.url));
      }
      if (error?.response?.status === 400) {
        const message = error.response.data.hasOwnProperty("message")
          ? error.response.data.message
          : error.response.data;
        toast.warning(message);
      }
      if (error?.response?.status === 401 || error?.response?.status === 403) {
        toast.error("Unauthorized");
        setTimeout(function() {
          window.location.replace(`/logout`);
        }, 1000);
      }
      if (error?.response?.status === 404) {
        toast.error(error.response.data);
      }
      if (error?.response?.status === 500) {
        const message = error.response.data.hasOwnProperty("message")
          ? error.response.data.message
          : error.data !== undefined
          ? error.data
          : error;
        window.location.replace(`/error/error500/${message}`);
      }
      return Promise.reject(error);
    }
  );
}

//500 : GUID: Tiene que ir a una página donde muestre el error, y vero el tema de la traducción
//400 Bad Request: Para todas las exceptions de NEGOCIO, MULTIIDIOMA
